import Swiper from "swiper";
import { Autoplay, Navigation, Pagination  } from "swiper/modules";

const initKingsHomeCollections = (element) => {
  let section_id = element.getAttribute('data-section-id');
  let selector = '#' + element.id;
  new Swiper(selector, {
    modules: [Autoplay, Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 20,
    loop: false,
    centeredSlides: false,
    centerInsufficientSlides: true,
    loopedSlides: 4,
    roundLengths: true,
    speed: 1000,
    breakpoints: {
      280: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      490: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      800: {
        slidesPerView: 3,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20
      }
    },
    pagination: {
      clickable: true,
      el: '.swiper-pagination',
      clickable: true,
  },
    navigation: {
      prevEl: `.kings-home-collection__buttons--prev--${section_id}`,
      nextEl: `.kings-home-collection__buttons--next--${section_id}`
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const kingsHomeCollectionEl = [...document.querySelectorAll('.relate-products__slider')];
  kingsHomeCollectionEl.map(element => initKingsHomeCollections(element));
});